import React, { useState } from "react";

import "./Basket.css";

import {
  ListItem,
  ListItemText,
  InputBase,
  Checkbox,
  ListItemSecondaryAction,
  IconButton,
  Button,
} from "@mui/material";

import DeleteOutlined from "@mui/icons-material/DeleteOutlined";

export const TodoBasket = (props) => {
  const [item, setItem] = useState(props.item);
  const [readOnly, setReadOnly] = useState(true);
  const deleteItem = props.deleteItem;
  const editItem = props.editItem;

  const editEventHandler = (e) => {
    console.log("editEventHandler");
    let count = e.target.value;
    const passwordRegex = /^[0-9]+$/;
    if (!count) {
      count = 0; //item.count;
    }
    if (!passwordRegex.test(count)) {
      alert("숫자만 가능합니다.");
      return;
    }
    if (count > 10000) {
      alert("10000개 이하만 가능합니다.");
      return;
    }
    if (count == 0) {
      setItem({ ...item, count: "" });
    } else {
      setItem({ ...item, count: count });
    }
    //item.title = e.target.value;
    console.log(item);
    //editItem();
  };

  const checkboxEventHandler = (e) => {
    console.log("checkboxEventHandler");
    // item.done = e.target.checked;
    if (!item.count) {
      alert("상품갯수가 비어있습니다.");
      return;
    }
    console.log(item);
    editItem(item);
  };

  // deleteEventHandler 작성
  const deleteEventHandler = () => {
    console.log("deleteEventHandler");
    if (!window.confirm("do you want to delete it?")) {
      return;
    }
    deleteItem(item);
  };

  const turnOffReadOnly = () => {
    console.log("turnOffReadOnly");
    setReadOnly(false);
  };

  // turnOnReadOnly 함수 작성
  const turnOnReadOnly = (e) => {
    console.log("turnOnReadOnly");

    if (e.key === "Enter" && readOnly === false) {
      if (!window.confirm("do you want to update it?")) {
        return;
      }

      setReadOnly(true);
      editItem(item);
    }
  };

  return (
    <ListItem>
      {/* <Checkbox checked={item.done} onChange={checkboxEventHandler} /> */}
      {/*<ListItemText> </ListItemText>
      <ListItemSecondaryAction></ListItemSecondaryAction>
      */}
      <td></td>
      <InputBase
        className="input"
        inputProps={{
          "aria-label": "naked",
          readOnly: readOnly,
        }}
        onClick={turnOffReadOnly}
        onKeyDown={turnOnReadOnly}
        onChange={editEventHandler}
        type="text"
        id={item.id}
        name={item.id}
        value={item.count}
        multiline={true}
        fullWidth={true}
      />

      <button
        className="update"
        variant="contained"
        color="success"
        onClick={checkboxEventHandler}
      >
        갯수 수정
      </button>
    </ListItem>
  );
};

export default TodoBasket;
